import { IPicture } from '@api/models/image/picture';
import { Team } from '@api/models/team/team';
import {ISponsor} from '@api/models/sponsor/sponsor';

export enum RegistrationStatus {
  NOT_REGISTERED = 'not_registered',
  REGISTERED = 'registered',
  SELECTED = 'selected',
  CONFIRMED = 'confirmed'
}

export enum LiveReporterStatus {
  OPEN = 'open',
  IMMEDIATELY = 'immediately',
  CLOSED = 'closed',
  EVALUATED = 'evaluated',
  DISABLED = 'disabled',
}

export interface IEventTeamReporter {
  firstname: string;
  internal: boolean;
  lastname: string;
  type: string;
  userid: string;
  username: string;
}

export interface IEventLiveReporter {
  status: LiveReporterStatus;
  moderatorid: string;
  registration_timestamps: {
    open: number;
    closed: number;
  };
  checked: boolean;
  firstname: string;
  lastname: string;
  username: string;
  user_registration_process_status: RegistrationStatus
}

export interface ILineupPlayer {
  playerid: string
  playername: string,
  firstname: string,
  lastname: string,
  position: string,
  number: number,
  captain: boolean,
}

export interface IEventTeam extends Team {
  teamid: string;
  name: string;
  abbreviation: string;
  score: number;
  goals: any[];
  formation: number;
  lineup: ILineupPlayer[][];
  reserve: ILineupPlayer[];
  live_lineup: {
    lineup: ILineupPlayer[][]
    reserve: ILineupPlayer[]
    replaced: ILineupPlayer[]
  };
  squad_confirmed: boolean;
  event_finished: boolean;
  shared_activities: string;
  fan_moderator: IEventLiveReporter;
  automation: boolean;
  delayed_evaluation: boolean;
  moderators: IEventTeamReporter[];
  moderated: boolean;
  moderation_type: string;
  liveticker: boolean;
  lineup_shared: boolean;
  pictures: IPicture[];
  readable_id: string;
  sponsors: ISponsor[];
  sponsor: ISponsor;
  primary_color: string;
}
